import { render, staticRenderFns } from "./ServicesInvoice.vue?vue&type=template&id=b8ba8d92&scoped=true"
import script from "./ServicesInvoice.vue?vue&type=script&lang=js"
export * from "./ServicesInvoice.vue?vue&type=script&lang=js"
import style0 from "./ServicesInvoice.vue?vue&type=style&index=0&id=b8ba8d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ba8d92",
  null
  
)

export default component.exports